import _styled from '@emotion/styled/base';
import { VISUAL_ELEMENT_SIZE_MAP } from './constants.js';
import { border } from '@hubble/tokens/web';

const StyledImg = _styled('img', {
  target: "e18fz4370"
})(({
  theme,
  size,
  border: border$1
}) => ({
  display: 'block',
  borderRadius: border.radius.full,
  height: VISUAL_ELEMENT_SIZE_MAP[size],
  minHeight: VISUAL_ELEMENT_SIZE_MAP[size],
  width: VISUAL_ELEMENT_SIZE_MAP[size],
  minWidth: VISUAL_ELEMENT_SIZE_MAP[size],
  border: border$1 ? `1px solid ${theme.colorScheme.border.primary}` : 0,
  boxSizing: 'border-box'
}));

export { StyledImg };
